import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserFormComponent } from './user-form/user-form.component';
import { UsersComponent } from './users/users.component';
import { UsersListComponent } from './users-list/users-list.component';
import { UsersDataService } from '@app/users/users-data.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FormsModule } from '@angular/forms';
import {
  MatListModule,
  MatDialogModule,
  MatButtonModule,
  MatCardModule,
  MatInputModule,
  MatSelectModule,
  MatTableModule,
  MatSortModule,
  MatPaginatorModule,
  MatTooltipModule,
  MatIconModule
} from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { TranslateModule } from '@ngx-translate/core';
import { DeleteUserComponent } from './delete-user/delete-user.component';


@NgModule({
  imports: [
    CommonModule,
    MatListModule,
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatIconModule,
    TranslateModule,
    InfiniteScrollModule,
    FormsModule,
    MatSortModule,
  ],
  declarations: [
    UserFormComponent,
    UsersComponent,
    UsersListComponent,
    UserDetailComponent,
    DeleteUserComponent,
  ],
  providers: [UsersDataService],
  entryComponents: [UserFormComponent, DeleteUserComponent]
})
export class UsersModule { }



// WEBPACK FOOTER //
// ./src/app/users/users.module.ts